import React, { Dispatch } from 'react';
import IFund from '../../interfaces/fund/IFund';
import IFundFilters from '../../interfaces/fund/IFundFilters';
import VInvestFundPerformanceVentureCapital from './VInvestFundPerformanceVentureCapital';

type VInvestFundPerformancePrivateEquityProps = {
	fund: IFund;
	filters: IFundFilters;
	setDataUpdatedOn: Dispatch<Date>;
};

const VInvestFundPerformancePrivateEquity = (props: VInvestFundPerformancePrivateEquityProps) => {
	const { fund, filters, setDataUpdatedOn } = props;

	return <VInvestFundPerformanceVentureCapital fund={fund} filters={filters} setDataUpdatedOn={setDataUpdatedOn} />;
};

export default VInvestFundPerformancePrivateEquity;
